import styles from '../boxAlert/css/boxAlert.module.css';


export default function Sended({ companyName }) {
  return (
    <div className={styles.alertComponent}>
      <div className={styles.overlayCart}></div>

      <div className={styles.alertBox}>
        <h1 className={styles.titleAlertBox} style={{ marginBottom: 0 }}>
          Avaliação enviada
        </h1>

        <p className={styles.textAlertBox} style={{ paddingBottom: 60 }}>
          Sua avaliação foi recebida com sucesso! Muito obrigado pelo seu tempo
          e esperamos que nós do(a) {companyName} tenhamos entregado o melhor
          serviço possível para você!
        </p>
      </div>
    </div>
  );
}
